import {
  SAVE_MESSAGES,
  SAVE_UNREAD_MESSAGES,
  SET_MESSAGE_LIST_BACK,
  SET_MESSAGE_LOADING,
} from "../actions/types";

const initialState = {
  loadingState: false,
  messagesList: {},
  messageCounter: 0,
  isChangeToList: 0
};

export const MessagesReducer = (state = initialState, action: any) => {
  const oldState = { ...state };
  const { type, payload } = action;
  switch (type) {
    case SET_MESSAGE_LOADING:
      return {
        ...oldState,
        loadingState: payload,
      };

    case SAVE_MESSAGES:
      return {
        ...oldState,
        messagesList: payload,
      };

    case SAVE_UNREAD_MESSAGES:
      return {
        ...oldState,
        messageCounter: payload,
      };

    case SET_MESSAGE_LIST_BACK:
     
      return {
        ...oldState,
        isChangeToList: payload,
      };


  }
  return oldState;
};
